export default "__VITE_ASSET__52ccec0f__"